import {LoadingButton} from '@mui/lab';
import {
    Box,
    Button,
    Chip,
    Container,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    Grid,
    Stack,
    Typography,
} from '@mui/material';
import {DataGrid} from '@mui/x-data-grid';
import {useFormik} from 'formik';
import {useSnackbar} from 'notistack';
import {useMemo, useState} from 'react';
import {useNavigate} from 'react-router-dom';
import server from '../../../global/server';
import {useFetch} from '../../../hooks/useFetch';
import useHandleErrors from '../../../hooks/useHandleErrors';
import ReportForm from '../components/ReportForm';
import AppointmentTabs from '../components/AppointmentTabs';
import {Check, CloseRounded} from '@mui/icons-material';

export default () => {
    const navigation = useNavigate();
    const {data, mutate, error, isFetching} = useFetch('/appointment');
    const [errs, setErrs] = useState();

    const [viewDialog, setViewDialog] = useState(false);
    const {enqueueSnackbar} = useSnackbar();
    useHandleErrors(errs);

    const {
        handleChange,
        handleSubmit,
        handleReset,
        setValues,
        setFieldValue,
        values,
        errors,
        isSubmitting,
    } = useFormik({
        initialValues: {
            equipment_id: '',
            reportAt: '',
            Report_files: [],
        },
        onSubmit: async (values, {setSubmitting}) => {
            try {
                setSubmitting(true);

                console.log(values);
                if (values.id) {
                    const {data} = await server.put(`/appointment`, values);
                    setValues(data.data, true);
                    enqueueSnackbar('Laudo alterado');
                    // setViewDialog(false);
                } else {
                    const {data} = await server.post(`/appointment`, values);

                    setValues(data.data, true);
                    enqueueSnackbar('Laudo adicionado');
                }
                setSubmitting(false);
                await mutate();
            } catch (error) {
                console.log(error);
                setSubmitting(false);
                //setErrs(error);
            }
        },
    });

    const columns = useMemo(() => [
        {field: 'id', headerName: 'ID', width: 50},
        // {
        //     field: 'identufy',
        //     headerName: 'Identificador',
        //     flex: 1,
        //     minWidth: 250,
        //     renderCell: ({value}) => (
        //         <Box
        //             component="img"
        //             sx={{
        //                 width: 35,
        //                 height: 35,
        //                 objectFit: 'cover',
        //                 borderRadius: 50,
        //                 overflow: 'hidden',
        //             }}
        //             src={value}
        //         />
        //     ),
        // },
        {
            field: 'datetime',
            headerName: 'Data',
            flex: 1,
            minWidth: 200,
            valueGetter: (value, row) =>
                value
                    ? new Date(value)?.toLocaleString('pt-BR', {
                          dateStyle: 'short',
                          timeStyle: 'medium',
                      })
                    : '--',
        },
        {
            field: 'Professional',
            headerName: 'Profissional',
            flex: 1,
            minWidth: 250,
            valueGetter: value => value?.User?.Person?.name || '--',
        },

        {
            field: 'Customer',
            headerName: 'Paciente',
            flex: 1,
            valueGetter: (value, row) => row?.Customer?.name || '--',
        },

        {
            field: 'duty_id',
            headerName: 'Plantão',
            flex: 1,
            valueGetter: (value, row) => Boolean(value),
            renderCell: ({value}) => value ? <Check />: <CloseRounded />
        },

        {
            field: 'product',
            headerName: 'Especialidade/Produto',
            flex: 1,
            valueGetter: (value, row) => row?.Product.name || '--',
        },
        {
            field: 'status',
            headerName: 'Status do atendimento',
            flex: 1,
            valueGetter: (value, row) => value || 'NOT_COMPLET',
        },
        {
            field: 'payment_status',
            headerName: 'Status do pagamento',
            flex: 1,
            valueGetter: (value, row) =>  row.voluntary? 'VOLUNTARY': value || 'NOT_PAYMENT',
            renderCell: ({value})=> <Chip variant='danger' label={value} />
        },
        {
            field: 'actions',
            //headerName: 'actions',
            type: 'actions',
            renderCell: ({row}) => (
                <Button
                    size="small"
                    variant="outlined"
                    onClick={e => {
                        setValues(
                            {
                                ...row,
                                // preview_image: row.image,
                                // category_id: row.Categories.map(cat => cat.category_id),
                            },
                            true,
                        );
                        setViewDialog(true);
                    }}>
                    Detalhes
                </Button>
            ),
        },
    ]);

    const [submitting, setSubmitting] = useState(false);

    // const excluir = async id => {
    //     try {
    //         setSubmitting(true);
    //         await server.delete('/points', { data: { id } });
    //         enqueueSnackbar('Item removido');
    //         setSubmitting(false);
    //         mutate();
    //         handleReset();
    //         setViewDialog(false);
    //     } catch (error) {
    //         setSubmitting(false);
    //         setErrs(error);
    //     }
    // };

    return (
        <Container fixed>
            <Stack direction="row" justifyContent="space-between" alignItems="center" my={3}>
                <Typography variant="h5" component="h2">
                    Agendamentos
                </Typography>
                {/* <Stack direction="row" alignItems="center" columnGap={2}>
                    <Button variant="contained" onClick={e => setViewDialog(true)}>
                        Adicionar laudo
                    </Button>
                </Stack> */}
            </Stack>
            <DataGrid autoHeight loading={isFetching} rows={data || []} columns={columns} />
            <Dialog
                maxWidth="sm"
                fullWidth
                open={viewDialog}
                onClose={e => {
                    handleReset();
                    setViewDialog(false);
                }}>
                <DialogTitle>{values.id ? `Atendimento: ${values.id}` : 'Novo laudo'}</DialogTitle>
                <DialogContent>
                    {values.id && (
                        <AppointmentTabs
                            values={values}
                            handleChange={handleChange}
                            setFieldValue={setFieldValue}
                            errors={errors}
                        />
                    )}
                </DialogContent>
                <DialogActions>
                    <Button onClick={e => setViewDialog(false)}>Cancelar</Button>
                    <LoadingButton onClick={handleSubmit}>Salvar</LoadingButton>
                </DialogActions>
            </Dialog>
        </Container>
    );
};
